require('sass/brands/locations.ncsecu.org/location/default.scss');
require('js/location-script.js');
